import {PLATFORM, DOM} from 'aurelia-framework';
import {get} from 'lodash';

export class ContentService {

  showGroupApplication() {
    return this.showHome();
  }

  showGroupDirectory(groupGuid) {
    return new Promise(resolve => {
      showGroup(groupGuid, resolve, true);
    });
  }

  showGroupSettings(groupId) {
    return new Promise(resolve => {
      editGroup(groupId, resolve);
    });
  }

  showGroupReports(groupId) {
    return this.__showContent('group_reports', {groupId});
  }

  showHome(paneId?: any) {
    //FIXME: temporary implementation till complete aurelia migration
    let notAtHome = get(DOM.getElementById('widget_cont'), 'style.display', 'none') === 'none';
    if(notAtHome) {
        $("#widget_cont").show();
        return this.__showContent('home');
    } else {
        return Promise.resolve();
    }
    //return notAtHome ? this.__showContent('home') : Promise.resolve();
  }

  openOnebox() {
    void this.__showContent('onebox');
  }

  openNotifications() {
    void this.__showContent('notifications');
  }

  openGroupSettings() {
    void this.__showContent('groups4');
  }

  openWidgets() {
    void this.__showContent('widgets');
  }

  openRingplans() {
    void this.__showContent('ringplans');
  }

  openContacts() {
    void this.__showContent('contacts');
  }

  openSearch() {
    return void this.__showContent('search/main');
  }

  showKeypad() {
    PLATFORM.global.openKeypad();
  }

  editUserProfile(params) {
    this.__showContent('profile3', params);
  }

  deactivateProfile() {
    PLATFORM.global.deactivate();
  }

  saveContactProperty(action, contactId) {
    return new Promise(resolve => PLATFORM.global.saveContactProperty(action, contactId, resolve));
  }

  showUser(nickname, groupId?: number) {
    return new Promise(resolve => {
      PLATFORM.global.showUser(nickname, groupId, resolve);
    });
  }

  getUserInfo() {
    return PLATFORM.global.getInitiatorInfo();
  }

  loadContent(url) {
    loadToContent(url);
  }

  addRingPlan() {
    PLATFORM.global.rpNew();
  }

  backToRingPlans() {
    PLATFORM.global.backToList();
  }

  sendGroupsInvitation(userId, groupIds) {
    return new Promise(resolve => PLATFORM.global.invieCommand(userId, 'GROUP_LIST', groupIds, resolve));
  }

  showTiedWidgets() {
    void this.__showContent('widgets');
  }

  showWidgetStore() {
    void this.__showContent('widget_store');
  }

  private __showContent(pageName: string, params?: any): Promise<void> {
    return new Promise(resolve => {
      PLATFORM.global.repaintContent(pageName, resolve, params);
    });
  }

}
